import script from "./DownloadView.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadView.vue?vue&type=script&setup=true&lang=js"

import "./DownloadView.vue?vue&type=style&index=0&id=171b1443&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171b1443"]])

export default __exports__